// @ts-nocheck
import { useState } from 'react';
import styled from 'styled-components';
import { BoxSingleCard, MainListContainer, SpaceSingleCard } from './GenericCssComponent';
import colors from '../../../../styles/colors';
import { useNavigate } from 'react-router-dom';

const ContainerSelect = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 10px;
    position: relative;
    z-index: 1000;

    & select.select-year {
        width: 90%;
        padding: 10px;
        border: 1px solid white;
        border-radius: 5px;
        background-color: ${colors.bgColorBlack};
        color: white;
        text-align: center;
        font-weight: 600;
        font-size: 16px;
        position: relative;

        /* Stile del dropdown (opzioni) */
        & option {
            background-color: ${colors.bgColorBlack2};
            color: white;
            font-size: 14px;
            padding: 8px;
            text-align: center;
            font-weight: 600;
        }
    }
`

const ThisContainerListPpv = styled.div `
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 95%;
    background-color: ${colors.bgColorBlack2};
    border-radius: 15px;
    overflow: hidden;
    margin: 0 auto;
    color: white;
    padding: 10px 0;
`

function RenderByYearAllListPpv({listPpvByYear}) {
    const navigate = useNavigate();
    
    // Funzione che mi prende gli anni dalla chiave di listPpvByYear e li ordina dal più recente al più vecchio
    function getSortedYears() {
        return Object.keys(listPpvByYear || {}).sort((a, b) => b - a);
    }
    
    // Array degli anni ordinati dal più recente al più vecchio
    const arrayAllYears = getSortedYears();
    const [selectedYear, setSelectedYear] = useState(arrayAllYears[0] || '');
    
    // Calcola selectedListPpv basandosi su selectedYear
    const selectedListPpv = listPpvByYear?.[selectedYear] || [];

    // Funzione sull on change della select che mi aggiorna il selectedYear
    function handleChangeYear(event) {
        setSelectedYear(event.target.value);
        // selectedListPpv si aggiorna automaticamente grazie al calcolo sopra
    }

    // Funzione per navigare alla pagina specifica del ppv
    function navigateToSpecificPpv(ppv) {
        const ppvId = ppv.id;
        const ppvName = ppv.ppv_description.name;
        let url = '/ppv/specific/i_' + ppvId + '_d_' + ppvName;
        navigate(url);
    }

    // Renderizazzione del select
    function renderSelect() {
        return (
            <ContainerSelect className='container-select'>
                <select 
                    className='select-year' 
                    id='select-year-list-ppv-id'
                    onChange={handleChangeYear}
                > 
                    {arrayAllYears.map((year, index) => (
                        <option key={index} value={year}>{year}</option>
                    ))}
                </select>
            </ContainerSelect>
        )
    }

    // Renderizazzione della lista dei ppv
    function renderListPpv() {
        if (!selectedListPpv || selectedListPpv.length === 0) {
            return (
                <MainListContainer className='main-list-container'>
                    <div style={{ textAlign: 'center', padding: '20px', color: 'white' }}>
                        Nessun PPV trovato per l'anno {selectedYear}
                    </div>
                </MainListContainer>
            );
        }

        return (
            <MainListContainer className='main-list-container'>
                {selectedListPpv.map((ppv, index) => (
                    <SpaceSingleCard key={ppv.id} className='space-single-card right' 
                     onClick={() => navigateToSpecificPpv(ppv)}
                     id={'ppv-' + ppv.id}
                    >
                        <BoxSingleCard className='box-single-card right'>
                            <img 
                                src={process.env.REACT_APP_STORAGE_URL + ppv.img_path} 
                                alt={ppv.img_path + "_alt"} 
                                className='poster-ppv' 
                            />
                            <div className='box-info-ppv right'>
                                {ppv.ppv_description?.name || 'Nome non disponibile'}
                            </div>
                        </BoxSingleCard>
                    </SpaceSingleCard>
                ))}
            </MainListContainer>
        )
    }

    return (
        <ThisContainerListPpv className='this-container-list-ppv'>
            {/* Select con lista degli anni. Default selezionato l'anno più recente. */}
            {renderSelect()}

            {/* Lista dei ppv */}
            {renderListPpv()}

        </ThisContainerListPpv>
    )
}

export default RenderByYearAllListPpv;